import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LoadingPanel from "../../../components/feedback/LoadingPanel";
import {
  authActions,
  loginWithCredentials,
  verifyMfaCode,
  forgotPassword,
  verifyResetCode,
  resetPassword,
  register,
  verifyRegistration,
} from "../../../store";
import LoginAAD from "./LoginAAD";
import "./login.css";
export { Login };

function Login() {
  const isLoading = useSelector((x) => x.auth.isLoading);
  const error = useSelector((x) => x.auth.error);
  const isMfa = useSelector((x) => x.auth.isMfa);
  const storedMfaMethod = useSelector((x) => x.auth.mfaMethod);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  // const [mfaMethod, setMfaMethod] = useState("authenticator"); // authenticator şimdilik kapalı
  const mfaMethod = "email";
  const [mfaCode, setMfaCode] = useState("");

  // Password reset states
  const [resetStep, setResetStep] = useState(null); // null | 1 (email) | 2 (code) | 3 (new password)
  const [resetEmail, setResetEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);

  // Registration states
  const [registerStep, setRegisterStep] = useState(null); // null | 1 (form) | 2 (verification)
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regConfirmPassword, setRegConfirmPassword] = useState("");
  const [regFirstName, setRegFirstName] = useState("");
  const [regLastName, setRegLastName] = useState("");
  const [regCode, setRegCode] = useState("");
  const [regSuccess, setRegSuccess] = useState(false);

  const handleCredentialsLogin = (e) => {
    e.preventDefault();

    // Super user offline login (development only)
    if (
      process.env.NODE_ENV === "development" &&
      email === "daiking@daikin.com.tr" &&
      password === "Daikin123"
    ) {
      dispatch(authActions.offlineLogin({ email }));
      return;
    }

    // Normal backend login
    dispatch(loginWithCredentials({ email, password, mfaMethod }));
  };

  const handleMfaVerify = (e) => {
    e.preventDefault();
    dispatch(
      verifyMfaCode({ code: mfaCode, method: storedMfaMethod || mfaMethod }),
    );
  };

  const handleForgotPasswordClick = () => {
    setResetStep(1);
    setResetEmail(email); // Eğer email girilmişse onu kullan
  };

  const handleForgotPasswordSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword({ email: resetEmail })).then((result) => {
      if (result.type && result.type.endsWith("/fulfilled")) {
        setResetStep(2);
      }
    });
  };

  const handleVerifyResetCode = (e) => {
    e.preventDefault();
    dispatch(verifyResetCode({ email: resetEmail, code: resetCode })).then(
      (result) => {
        if (result.type && result.type.endsWith("/fulfilled")) {
          setResetStep(3);
        }
      },
    );
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return;
    }
    dispatch(resetPassword({ email: resetEmail, password: newPassword })).then(
      (result) => {
        if (result.type && result.type.endsWith("/fulfilled")) {
          setResetSuccess(true);
          setTimeout(() => {
            setResetStep(null);
            setResetSuccess(false);
            setResetEmail("");
            setResetCode("");
            setNewPassword("");
            setConfirmPassword("");
          }, 2000);
        }
      },
    );
  };

  const handleBackToLogin = () => {
    setResetStep(null);
    setResetEmail("");
    setResetCode("");
    setNewPassword("");
    setConfirmPassword("");
    setResetSuccess(false);
  };

  const handleRegisterClick = () => {
    setRegisterStep(1);
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    if (regPassword !== regConfirmPassword) {
      return;
    }

    dispatch(
      register({
        email: regEmail,
        password: regPassword,
        firstName: regFirstName,
        lastName: regLastName,
      }),
    ).then((result) => {
      if (result.type && result.type.endsWith("/fulfilled")) {
        setRegisterStep(2);
      }
    });
  };

  const handleVerifyRegistration = (e) => {
    e.preventDefault();
    dispatch(
      verifyRegistration({
        email: regEmail,
        code: regCode,
        password: regPassword,
      }),
    ).then((result) => {
      if (result.type && result.type.endsWith("/fulfilled")) {
        setRegSuccess(true);
        setTimeout(() => {
          setRegisterStep(null);
          setRegSuccess(false);
          setRegEmail("");
          setRegPassword("");
          setRegConfirmPassword("");
          setRegFirstName("");
          setRegLastName("");
          setRegCode("");
        }, 2000);
      }
    });
  };

  const handleBackToLoginFromRegister = () => {
    setRegisterStep(null);
    setRegEmail("");
    setRegPassword("");
    setRegConfirmPassword("");
    setRegFirstName("");
    setRegLastName("");
    setRegCode("");
    setRegSuccess(false);
  };

  const renderResetPasswordContent = () => {
    // Step 1: Email girişi
    if (resetStep === 1) {
      return (
        <>
          <div className="supplier-form-section">
            <form onSubmit={handleForgotPasswordSubmit}>
              <div className="form-fields">
                <h3 className="reset-password-title">{t("forgot-password")}</h3>
                <div className="mfa-instruction-text">
                  {t("forgot-password-instruction")}
                </div>
                <div className="modern-form-field">
                  <input
                    className="k-textbox"
                    type="email"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    autoComplete="email"
                    placeholder={t("email")}
                    required
                  />
                </div>
                {error && (
                  <div className="modern-error">
                    <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                      {error.message}
                    </span>
                  </div>
                )}
                <div className="modern-form-buttons">
                  <button
                    type="submit"
                    className="modern-verify-button k-button"
                    disabled={isLoading}
                  >
                    <i className="fas fa-paper-plane"></i>&nbsp; {t("send")}
                  </button>
                </div>
                <div className="login-back-wrap">
                  <button
                    type="button"
                    className="back-button"
                    onClick={handleBackToLogin}
                  >
                    <i className="fas fa-chevron-left"></i>&nbsp; {t("back")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      );
    }

    // Step 2: Doğrulama kodu girişi
    if (resetStep === 2) {
      return (
        <>
          <div className="login-app-title">
            <span>DAIKING</span>
          </div>
          <div className="supplier-form-section">
            <form onSubmit={handleVerifyResetCode}>
              <div className="form-fields">
                <h3 className="reset-password-title">{t("verify-code")}</h3>
                <div className="mfa-instruction-text">
                  {t("reset-code-instruction")}
                </div>
                <div className="modern-form-field">
                  <input
                    className="k-textbox mfa-code-input"
                    type="text"
                    value={resetCode}
                    onChange={(e) =>
                      setResetCode(
                        e.target.value.replace(/\D/g, "").slice(0, 4),
                      )
                    }
                    maxLength={4}
                    inputMode="numeric"
                    placeholder="____"
                    required
                  />
                </div>
                {error && (
                  <div className="modern-error">
                    <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                      {error.message}
                    </span>
                  </div>
                )}
                <div className="modern-form-buttons">
                  <button
                    type="submit"
                    className="modern-verify-button k-button"
                    disabled={isLoading || resetCode.length !== 4}
                  >
                    <i className="fas fa-check"></i>&nbsp; {t("verify")}
                  </button>
                </div>
                <div className="login-back-wrap">
                  <button
                    type="button"
                    className="back-button"
                    onClick={handleBackToLogin}
                  >
                    <i className="fas fa-chevron-left"></i>&nbsp; {t("back")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      );
    }

    // Step 3: Yeni şifre girişi
    if (resetStep === 3) {
      return (
        <>
          <div className="login-app-title">
            <span>DAIKING</span>
          </div>
          <div className="supplier-form-section">
            <form onSubmit={handleResetPassword}>
              <div className="form-fields">
                <h3 className="reset-password-title">
                  {t("set-new-password")}
                </h3>
                {resetSuccess ? (
                  <div className="reset-success-message">
                    <i className="fas fa-check-circle"></i>&nbsp;{" "}
                    {t("password-reset-success")}
                  </div>
                ) : (
                  <>
                    <div className="modern-form-field">
                      <input
                        className="k-textbox"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        autoComplete="new-password"
                        placeholder={t("new-password")}
                        required
                        minLength={6}
                      />
                    </div>
                    <div className="modern-form-field">
                      <input
                        className="k-textbox"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        placeholder={t("confirm-password")}
                        required
                        minLength={6}
                      />
                    </div>
                    {newPassword &&
                      confirmPassword &&
                      newPassword !== confirmPassword && (
                        <div className="modern-error">
                          <span
                            style={{ color: "#dc2626", fontSize: "0.875rem" }}
                          >
                            {t("password-mismatch")}
                          </span>
                        </div>
                      )}
                    {error && (
                      <div className="modern-error">
                        <span
                          style={{ color: "#dc2626", fontSize: "0.875rem" }}
                        >
                          {error.message}
                        </span>
                      </div>
                    )}
                    <div className="modern-form-buttons">
                      <button
                        type="submit"
                        className="modern-verify-button k-button"
                        disabled={
                          isLoading ||
                          !newPassword ||
                          !confirmPassword ||
                          newPassword !== confirmPassword
                        }
                      >
                        <i className="fas fa-key"></i>&nbsp;{" "}
                        {t("reset-password")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
        </>
      );
    }

    return null;
  };

  const renderRegisterContent = () => {
    // Step 1: Kayıt formu
    if (registerStep === 1) {
      return (
        <>
          <div className="supplier-form-section">
            <form onSubmit={handleRegisterSubmit}>
              <div className="form-fields">
                <h3 className="reset-password-title">{t("register-title")}</h3>
                <div className="register-form-grid">
                  <div className="modern-form-field">
                    <input
                      className="k-textbox"
                      type="text"
                      value={regFirstName}
                      onChange={(e) => setRegFirstName(e.target.value)}
                      placeholder={t("first-name")}
                      required
                    />
                  </div>
                  <div className="modern-form-field">
                    <input
                      className="k-textbox"
                      type="text"
                      value={regLastName}
                      onChange={(e) => setRegLastName(e.target.value)}
                      placeholder={t("last-name")}
                      required
                    />
                  </div>
                </div>
                <div className="modern-form-field">
                  <input
                    className="k-textbox"
                    type="email"
                    value={regEmail}
                    onChange={(e) => setRegEmail(e.target.value)}
                    autoComplete="email"
                    placeholder={t("email")}
                    required
                  />
                </div>
                <div className="modern-form-field">
                  <input
                    className="k-textbox"
                    type="password"
                    value={regPassword}
                    onChange={(e) => setRegPassword(e.target.value)}
                    autoComplete="new-password"
                    placeholder={t("password")}
                    required
                    minLength={6}
                  />
                </div>
                <div className="modern-form-field">
                  <input
                    className="k-textbox"
                    type="password"
                    value={regConfirmPassword}
                    onChange={(e) => setRegConfirmPassword(e.target.value)}
                    autoComplete="new-password"
                    placeholder={t("confirm-password")}
                    required
                    minLength={6}
                  />
                </div>
                {regPassword &&
                  regConfirmPassword &&
                  regPassword !== regConfirmPassword && (
                    <div className="modern-error">
                      <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                        {t("password-mismatch")}
                      </span>
                    </div>
                  )}
                {error && (
                  <div className="modern-error">
                    <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                      {error.message}
                    </span>
                  </div>
                )}
                <div className="modern-form-buttons">
                  <button
                    type="submit"
                    className="modern-verify-button k-button"
                    disabled={
                      isLoading ||
                      !regPassword ||
                      !regConfirmPassword ||
                      regPassword !== regConfirmPassword
                    }
                  >
                    <i className="fas fa-user-plus"></i>&nbsp; {t("register")}
                  </button>
                </div>
                <div className="login-back-wrap">
                  <button
                    type="button"
                    className="back-button"
                    onClick={handleBackToLoginFromRegister}
                  >
                    <i className="fas fa-chevron-left"></i>&nbsp; {t("back")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      );
    }

    // Step 2: Doğrulama kodu
    if (registerStep === 2) {
      return (
        <>
          <div className="supplier-form-section">
            <form onSubmit={handleVerifyRegistration}>
              <div className="form-fields">
                <h3 className="reset-password-title">
                  {t("verify-registration")}
                </h3>
                {regSuccess ? (
                  <div className="reset-success-message">
                    <i className="fas fa-check-circle"></i>&nbsp;{" "}
                    {t("registration-success")}
                  </div>
                ) : (
                  <>
                    <div className="mfa-instruction-text">
                      {t("registration-code-instruction")}
                    </div>
                    <div className="modern-form-field">
                      <input
                        className="k-textbox mfa-code-input"
                        type="text"
                        value={regCode}
                        onChange={(e) =>
                          setRegCode(
                            e.target.value.replace(/\D/g, "").slice(0, 4),
                          )
                        }
                        maxLength={4}
                        inputMode="numeric"
                        placeholder="____"
                        required
                      />
                    </div>
                    {error && (
                      <div className="modern-error">
                        <span
                          style={{ color: "#dc2626", fontSize: "0.875rem" }}
                        >
                          {error.message}
                        </span>
                      </div>
                    )}
                    <div className="modern-form-buttons">
                      <button
                        type="submit"
                        className="modern-verify-button k-button"
                        disabled={isLoading || regCode.length !== 4}
                      >
                        <i className="fas fa-check"></i>&nbsp; {t("verify")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
        </>
      );
    }

    return null;
  };

  const goBack = () => {
    dispatch(authActions.changeMfa());
  };

  const renderContent = () => {
    // Kayıt akışı
    if (registerStep) {
      return renderRegisterContent();
    }

    // Şifre sıfırlama akışı
    if (resetStep) {
      return renderResetPasswordContent();
    }

    // MFA kod doğrulama ekranı
    if (isMfa) {
      const activeMethod = storedMfaMethod || mfaMethod;
      return (
        <>
          <div className="login-app-title">
            <span>DAIKING</span>
          </div>
          <div className="supplier-form-section">
            <form onSubmit={handleMfaVerify}>
              <div className="form-fields">
                <div className="mfa-instruction-text">
                  {activeMethod === "email"
                    ? t("mfa-email-instruction")
                    : t("mfa-authenticator-instruction")}
                </div>
                <div className="modern-form-field">
                  <label className="k-label">{t("mfa-code")}</label>
                  <input
                    className="k-textbox mfa-code-input"
                    type="text"
                    value={mfaCode}
                    onChange={(e) =>
                      setMfaCode(e.target.value.replace(/\D/g, "").slice(0, 4))
                    }
                    maxLength={4}
                    autoComplete="one-time-code"
                    inputMode="numeric"
                    placeholder="____"
                    required
                  />
                </div>
                {error && (
                  <div className="modern-error">
                    <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                      {error.message}
                    </span>
                  </div>
                )}
                <div className="modern-form-buttons">
                  <Button
                    type="submit"
                    color="primary"
                    className="modern-verify-button k-button"
                    disabled={isLoading || mfaCode.length !== 4}
                  >
                    <i className="fas fa-shield-alt"></i>&nbsp;{" "}
                    {t("mfa-verify")}
                  </Button>
                </div>
                <div className="login-back-wrap">
                  <button
                    type="button"
                    className="back-button"
                    onClick={goBack}
                  >
                    <i className="fas fa-chevron-left"></i>&nbsp; {t("back")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      );
    }

    // Ana giriş ekranı
    return (
      <div className="login-main-form">
        <form onSubmit={handleCredentialsLogin}>
          <div className="form-fields">
            <div className="modern-form-field">
              <input
                className="k-textbox"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                placeholder={t("email")}
                required
              />
            </div>
            <div className="modern-form-field">
              <input
                className="k-textbox"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                placeholder={t("password")}
                required
              />
            </div>
            <div className="login-form-row">
              <label className="remember-me-label">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>{t("remember-me")}</span>
              </label>
              <button
                type="button"
                className="forgot-password-link"
                onClick={handleForgotPasswordClick}
              >
                {t("forgot-password")}
              </button>
            </div>
            {error && (
              <div className="modern-error">
                <span style={{ color: "#dc2626", fontSize: "0.875rem" }}>
                  {error.message}
                </span>
              </div>
            )}
            <button
              type="submit"
              className="modern-submit-button k-button"
              disabled={isLoading}
            >
              <i className="fas fa-sign-in-alt"></i>&nbsp; {t("login")}
            </button>
          </div>
        </form>

        <div className="login-divider">
          <span>{t("or")}</span>
        </div>

        <LoginAAD />

        <div className="login-register-row">
          <span>{t("no-account")}</span>
          <button
            type="button"
            className="register-link"
            onClick={handleRegisterClick}
          >
            {t("register")}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div id="modern-login-container">
      <div className="animated-background">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>

      <div className="geometric-pattern"></div>

      <div className="modern-form-wrapper">
        <div>
          <div className="modern-login-card">
            {isLoading && (
              <div className="login-loading-overlay">
                <LoadingPanel />
              </div>
            )}
            <div className="modern-login-header">
              <div className="animated-header-bg">
                <div className="floating-circle floating-circle-1"></div>
                <div className="floating-circle floating-circle-2"></div>
              </div>
              <div className="header-content">
                <h1 className="company-name">
                  <img
                    src={window.location.origin + "/logo2.png"}
                    style={{ maxHeight: "250px", alignSelf: "center" }}
                    alt="Daikin"
                  ></img>
                </h1>
              </div>
            </div>

            <div className="modern-login-content">
              <div className="login-options">{renderContent()}</div>
            </div>

 
          </div>
        </div>
      </div>
    </div>
  );
}
